<mat-progress-bar *ngIf="_loader$" class="progress-bar" mode="indeterminate"></mat-progress-bar>
<router-outlet *ngIf="!isIframe"></router-outlet>

<div class="cross-tab-logout-overlay" *ngIf="appStateService.loggedOutElsewhere()" role="dialog" aria-modal="true" aria-labelledby="cross-tab-logout-title">
  <div class="cross-tab-logout-panel">
    <mat-icon class="cross-tab-logout-icon">logout</mat-icon>
    <h2 id="cross-tab-logout-title">You've been signed out</h2>
    <p>Click below to sign in again.</p>
    <button type="button" class="cross-tab-logout-button" (click)="reloadForLogout()">Sign in again</button>
  </div>
</div>
